/**
 * The customer card page: the card's qr code next to the card image.
 *
 * Markup contract (crm module, account/customercard.html.twig):
 *   <div x-data="customerCard({ cardNumber: '…' })">
 *     <div class="account_crm_image" x-ref="image"><img …></div>
 *     <div class="account_crm_qrcode" x-ref="frame"><canvas x-ref="canvas"></canvas></div>
 *
 * The code is drawn as a square that fits both the column it stands in and the
 * height of the card image next to it, and is redrawn whenever either changes.
 */
import QRious from 'qrious';

document.addEventListener('alpine:init', () => {
    Alpine.data('customerCard', ({ cardNumber }) => ({
        init() {
            const code = new QRious({
                element: this.$refs.canvas,
                value: `http://h1r.eu/${cardNumber}`,
                level: 'M',
                size: this.size(),
            });

            const observer = new ResizeObserver(() => { code.size = this.size(); });
            observer.observe(this.$refs.frame);
            observer.observe(this.$refs.image);
        },

        size() {
            return Math.round(Math.min(this.$refs.frame.clientWidth, this.$refs.image.clientHeight));
        },
    }));
});
